export class Materiel {
  id: number;
  libelle: string;
  activite: string;
  numeroLivraison: number;

  constructor(
    id: number,
    libelle: string,
    activite: string,
    numeroLivraison: number
  ) {
    this.id = id;
    this.libelle = libelle;
    this.activite = activite;
    this.numeroLivraison = numeroLivraison;
  }

  static factory(materielAPI: MaterielAPI): Materiel {
    return new Materiel(
      materielAPI.CodeDeclinaison ? materielAPI.CodeDeclinaison : materielAPI.ArticleCode,
      materielAPI.ArticleLibelle,
      materielAPI.ActivityCode,
      materielAPI.LivraisonNumero
    );
  }
}

export type MaterielAPI = {
  ActivityCode: string;
  ArticleCode: number;
  CodeDeclinaison?: number;
  ArticleLibelle: string;
  LignePrixHT: number;
  LivraisonNumero: number;
};
